module.exports = __webpack_public_path__ + "static/img/ent-34.5838790.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-34.jpg
// module id = Droe
// module chunks = 52